/* Native disclosures retain usable navigation without JavaScript. */
(function () {
  document.querySelectorAll('[data-navigation-disclosure]').forEach(function(disclosure) {
    var trigger = disclosure.querySelector('summary');
    disclosure.addEventListener('keydown', function(event) {
      if (event.key === 'Escape' && disclosure.open) {
        event.preventDefault();
        disclosure.open = false;
        trigger.focus();
      }
    });
    document.addEventListener('click', function(event) {
      if (disclosure.open && !disclosure.contains(event.target)) disclosure.open = false;
    });
  });
  var nav=document.querySelector('.nav');
  if(nav && 'IntersectionObserver' in window){
    var sentinel=document.createElement('span');sentinel.setAttribute('aria-hidden','true');
    Object.assign(sentinel.style,{position:'absolute',top:'0',width:'1px',height:'1px',pointerEvents:'none'});document.body.prepend(sentinel);
    new IntersectionObserver(function(entries){nav.classList.toggle('solid',!entries[0].isIntersecting);}).observe(sentinel);
  }
  var preference=matchMedia('(prefers-reduced-motion: reduce)');
  var veil=document.querySelector('.veil');
  var pending=false;
  var nativeRoute=/(?:^|\/)(?:cart|checkout|account)(?:\/|$)/;
  document.addEventListener('click',function(event){
    var link=event.target.closest&&event.target.closest('a[href]');
    if(!link||event.defaultPrevented||event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey||link.hasAttribute('download')||(link.target&&link.target!=='_self')||preference.matches||document.documentElement.hasAttribute('data-reduce-motion')||!veil)return;
    var target=new URL(link.href,location.href);
    if(target.origin!==location.origin||!/^https?:$/.test(target.protocol)||nativeRoute.test(target.pathname)||nativeRoute.test(location.pathname)||(target.pathname===location.pathname&&target.search===location.search))return;
    event.preventDefault();
    if(pending)return;pending=true;
    document.body.classList.add('leaving');
    veil.style.transitionDuration='220ms';veil.classList.remove('hide');
    setTimeout(function(){location.assign(target.href);},220);
  });
  addEventListener('pageshow',function(event){if(event.persisted){pending=false;document.body.classList.remove('leaving');if(veil){veil.style.transitionDuration='';veil.classList.add('hide');}}});
})();
